import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { handlePostRequest } from "../../../services/PostTemplate";
import { handlePutRequest } from "../../../services/PutTemplate";
import { SetEditCompanyProductFlagAction, SetCompanyProductFormDataToNullAction, GetCompanyProductDetailsAction } from "../../../redux/actions/companyAction";
import * as Yup from "yup";
import ZbizInput from "../../../components/zbizInput/ZbizInput";
import ZDropdown from "../../../components/zDropdown/ZDropdown";
import ZDropdownLink from "../../../components/zDropdownLink/ZDropdownLink";
import EnableorDisableCompProducts from "./EnableorDisableCompProducts";
import { useHistory } from "react-router-dom";

function AddEditCompanyProducts({ companyId, editable }) {

    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const dispatch = useDispatch();
    const history = useHistory()

    const editFlag__Store = useSelector((state) => state.companySlice?.companyProductEditFlag);
    const formData__Store = useSelector((state) => state.companySlice?.companyProductFormData);

    const handleCancel = (e) => {
        e.preventDefault();
        formik.resetForm();
        dispatch(SetEditCompanyProductFlagAction(false));
        dispatch(SetCompanyProductFormDataToNullAction());
    };

    const validationSchema = Yup.object().shape({
        parserHeadId: Yup.mixed().required("Required"),
        productId: Yup.mixed().required("Required"),
        limitPerDay: Yup.number().required("Required").min(10, "Limit per day must be at least 10"),
        limitPerMonth: Yup.number().required("Required")
            .when('limitPerDay', (limitPerDay, schema) => {
                return limitPerDay ? schema.min(limitPerDay, "Monthly limit should be greater than Daily limit") : schema;
            }),
        limitPerYear: Yup.number().required("Required")
            .when(['limitPerDay', 'limitPerMonth'], (limitPerDay, limitPerMonth, schema) => {
                return schema
                    .min(limitPerDay || 0, "Yearly limit should be greater than Daily limit")
                    .min(limitPerMonth || 0, "Yearly limit should be greater than Monthly limit")
                    .test({
                        test: function (value) {
                            const daily = this.resolve(limitPerDay);
                            const monthly = this.resolve(limitPerMonth);
                            return value >= daily && value >= monthly;
                        },
                        message: "Yearly limit should be greater than Daily and Monthly limit",
                    });
            })
            .when('limitPerMonth', (limitPerMonth, schema) => {
                return limitPerMonth ? schema.min(limitPerMonth, "Yearly limit should be greater than Monthly limit") : schema;
            })
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            limitPerDay: "10",
            limitPerMonth: "",
            limitPerYear: "",
            parserHeadId: "",
            productId: "",
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");

                if (editFlag__Store) {
                    data["companyProductId"] = formData__Store?.companyProductId;
                    data["companyId"] = parseInt(companyId);
                    const res = await handlePutRequest(data, "zbizgateway/nonFin/updateCompanyProducts");
                    if (res.status === 400) {
                        res?.data.forEach((element) => {
                            formik.setFieldError(element?.field, element?.message);
                        });
                    } else {
                        dispatch(SetEditCompanyProductFlagAction(false));
                        dispatch(SetCompanyProductFormDataToNullAction());
                    }
                } else {
                    data["companyId"] = parseInt(companyId);
                    if (data?.limitPerDay === null) {
                        data["limitPerDay"] = 0
                    }
                    if (data?.limitPerMonth === null) {
                        data["limitPerMonth"] = 0
                    }
                    if (data?.limitPerYear === null) {
                        data["limitPerYear"] = 0
                    }
                    const res = await handlePostRequest(data, "zbizgateway/nonFin/saveCompanyProducts");
                    if (res.status === 400) {
                        res?.data.forEach((element) => {
                            formik.setFieldError(element?.field, element?.message);
                        });
                    } else {
                        formik.resetForm();
                    }
                }
                getCompanyProductDetail();
            } catch (error) {
                console.error("An error occurred:", error);
            } finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const props = { onChange: formik.handleChange, values: formik.values, isFormFieldValid: isFormFieldValid, getFormErrorMessage: getFormErrorMessage };

    const getCompanyProductDetail = async () => {
        await dispatch(GetCompanyProductDetailsAction("zbizgateway/nonFin/getCompanyProduct/" + companyId));
    };

    const fillComapnyProductsForm = async () => {
        formik.setFieldValue("limitPerDay", formData__Store?.limitPerDay);
        formik.setFieldValue("limitPerMonth", formData__Store?.limitPerMonth);
        formik.setFieldValue("limitPerYear", formData__Store?.limitPerYear);
        formik.setFieldValue("productId", formData__Store?.tblProduct?.productId?.toString());
        formik.setFieldValue("parserHeadId", formData__Store?.tblParserHead?.parserHeadId?.toString());
    };

    useEffect(() => {
        if (editFlag__Store) {
            fillComapnyProductsForm();
        }
    }, [editFlag__Store, formData__Store]);

    useEffect(() => {
        formik.setFieldValue("limitPerDay", "")
        formik.setFieldValue("limitPerMonth", "")
        formik.setFieldValue("limitPerYear", "")
        formik.setFieldValue("productId", "")
        formik.setFieldValue("parserHeadId", "")
    }, []);

    return (
        <div>
            <div className="page_header">
                <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d_align">
                        <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />
                        <h3 className="mod_heading">Company Products</h3>
                    </div>
                </div>
            </div>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2 pos_relative">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Limit Per Day" keyName="limitPerDay" placeholder="Enter limit per day" {...props} type="number" required />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Limit Per Month" keyName="limitPerMonth" placeholder="Enter limit per month" {...props} type="number" required />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Limit Per Year" keyName="limitPerYear" placeholder="Enter limit per year" {...props} type="number" required />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZDropdown {...props} label="Product" required valueOption="id" keyName="productId" placeholder="Select Product" optionLabel="description" url="zbizgateway/lov/lovProduct" />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZDropdownLink {...props} linkId={formik.values.productId} label="Parser Head" required valueOption="id" keyName="parserHeadId" placeholder="Select Parser Head" optionLabel="description" url="zbizgateway/lov/lovParser" />
                            </div>
                        </div>
                    </div>
                    {
                        editable === "view" ? (<div className="overlay_field"></div>) : ""
                    }
                    {editable === "true" ? (
                        <div className="GenerateDown__Btn p-mt-4">
                            <EnableorDisableCompProducts handleCancel={handleCancel} getCompanyProductDetail={getCompanyProductDetail} />
                            <Button className="Btn__Transparent" label={editFlag__Store ? "Update" : "Add"} disabled={loading} type="submit" />
                            <Button className="Btn__Dark" label="Cancel" onClick={(e) => handleCancel(e)} type="button" />
                        </div>
                    ) : null}
                </form>
            </div>
        </div>
    );
}

export default AddEditCompanyProducts;
